<script setup lang="ts">
defineOptions({
  inheritAttrs: false,
});
</script>

<template>
  <ol class="list-outside list-decimal ml-32">
    <slot />
  </ol>
</template>
